module.exports = __webpack_public_path__ + "img/jy85-xcb-table.af271252.png";